import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Logo from '../logo'

import './footer.scss'

export default class Footer extends Component {
  render() {
    return (
      <footer className="app-footer container-fluid">
          <Logo isFooter={true} />
          <ul>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/imprint">Imprint</Link></li>
          </ul>
      </footer>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/shared/footer/index.jsx